import api from "./axios";
export const organizationApi = {
    getMine() {
        return api.get("/organizations/me");
    },
    getAll() {
        return api.get("/organizations", { orgContext: "global" });
    },
    getOne(id, options = {}) {
        return api.get(`/organizations/${id}`, options);
    },
    create(payload) {
        return api.post("/organizations", payload, { orgContext: "global" });
    },
    update(id, payload, options = {}) {
        return api.patch(`/organizations/${id}`, payload, options);
    },
    deactivate(id, payload = {}) {
        return api.post(`/organizations/${id}/deactivate`, payload, {
            orgContext: "global",
        });
    },
    reactivate(id, payload = {}) {
        return api.post(`/organizations/${id}/reactivate`, payload, {
            orgContext: "global",
        });
    },
    softDelete(id, payload) {
        return api.post(`/organizations/${id}/soft-delete`, payload, {
            orgContext: "global",
        });
    },
    getBankAccounts(id, options = {}) {
        return api.get(`/organizations/${id}/bank-accounts`, options);
    },
    createBankAccount(id, payload, options = {}) {
        return api.post(`/organizations/${id}/bank-accounts`, payload, {
            orgContext: "tenant",
            ...options,
        });
    },
    updateBankAccount(id, bankAccountId, payload, options = {}) {
        return api.patch(`/organizations/${id}/bank-accounts/${bankAccountId}`, payload, { orgContext: "tenant", ...options });
    },
    removeBankAccount(id, bankAccountId, options = {}) {
        return api.delete(`/organizations/${id}/bank-accounts/${bankAccountId}`, {
            orgContext: "tenant",
            ...options,
        });
    },
    getBrandTheme(id, options = {}) {
        return api.get(`/organizations/${id}/brand-theme`, options);
    },
    updateBrandTheme(id, payload, options = {}) {
        return api.patch(`/organizations/${id}/brand-theme`, payload, {
            orgContext: "tenant",
            ...options,
        });
    },
    getMembers(id) {
        return api.get(`/organizations/${id}/members`);
    },
    addMember(id, payload) {
        return api.post(`/organizations/${id}/members`, payload);
    },
    updateMember(id, userId, payload) {
        return api.patch(`/organizations/${id}/members/${userId}`, payload);
    },
    removeMember(id, userId) {
        return api.delete(`/organizations/${id}/members/${userId}`);
    },
};
export default organizationApi;
